module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai769-85ba1ce5be38442d90670345878aff7c.jpg";